import images from "../../../images";

export const CardQuestLocation = ({
  businessAvatar = "",
  handleFavoriteQuest,
  isFavorited,
  address = "",
  businessName,
  onFavoriteLocation,
  locationId,
  thumnail,
  handleNavigateToDetails,
}) => {
  return (
    <article
      onClick={handleNavigateToDetails}
      className="flex flex-col w-[130px] max-xs:w-[90px] flex-shrink-0 rounded-md cursor-pointer gap-1.5"
    >
      <div
        className="h-auto w-full self-stretch aspect-square rounded-md border border-light-grey bg-cover bg-center"
        style={{
          backgroundImage: businessAvatar
            ? `url(${process.env.REACT_APP_URL_IMAGE}/${businessAvatar})`
            : `url(${images.DefaultImageQuest})`,
        }}
      />

      <div className="flex flex-col justify-center items-start self-stretch gap-[3px]">
        <span
          className="text-dark-gray text-[14px] font-medium leading-[18px] line-clamp-2"
          title={businessName ? businessName : ""}
        >
          {businessName ? businessName : "Business Name"}
        </span>

        {address && (
          <p className="flex items-start gap-1 [&>span]:text-mid-gray [&>span]:text-sm">
            <span className="icon icon-location" />
            <span
              className="font-medium !leading-4"
              title={address ? address : ""}
            >
              {address ? address : ""}
            </span>
          </p>
        )}
      </div>
    </article>
  );
};
export default CardQuestLocation;
